namespace $.$$ {
	export class $shm_hitalama_map_widget_float_table_resize extends $.$shm_hitalama_map_widget_float_table_resize {
		private drag: { pointer: number, x: number, width: number, scale: number } | null = null

		@ $mol_action
		start( event?: PointerEvent ) {
			if( !event || event.button !== 0 || this.drag ) return
			event.preventDefault()
			event.stopPropagation()
			const head = this.dom_node().closest( 'th' ) as HTMLElement
			const rect = head.getBoundingClientRect()
			this.drag = { pointer: event.pointerId, x: event.clientX, width: head.offsetWidth, scale: rect.width / head.offsetWidth || 1 }
			this.dom_node().setPointerCapture( event.pointerId )
		}

		@ $mol_action
		move( event?: PointerEvent ) {
			const drag = this.drag
			if( !event || !drag || event.pointerId !== drag.pointer ) return
			event.preventDefault()
			event.stopPropagation()
			this.width( Math.max( 48, Math.round( drag.width + ( event.clientX - drag.x ) / drag.scale ) ) )
		}

		@ $mol_action
		end( event?: PointerEvent ) {
			if( !event || event.pointerId !== this.drag?.pointer ) return
			event.stopPropagation()
			this.drag = null
			if( this.dom_node().hasPointerCapture( event.pointerId ) ) this.dom_node().releasePointerCapture( event.pointerId )
		}

		@ $mol_action
		suppress( event?: Event ) {
			event?.preventDefault()
			event?.stopPropagation()
		}
	}
}
